export const normalizeURL = (url: string) => ({
  toHostName() {
    const urlConstructor = new URL(url);

    return urlConstructor.hostname;
  },
});
